import { colors, StyledIcon } from 'fitify-ui'
import { TextStyles } from 'fitify-ui-landing/src/components/Text'
import { phone, tabletPortrait } from 'fitify-ui-landing/src/theme/breakpoints'
import styled, { css } from 'styled-components'

export const StyledReviewsContainer = styled.div`
  padding-bottom: 120px;

  ${phone(css`
    padding-bottom: 60px;
  `)}
`

export const StyledReviewsWrapper = styled.div`
  display: flex;
  align-items: flex-start;
  align-self: stretch;
  gap: 24px;

  ${phone(css`
    flex-direction: column;
    gap: 16px;
  `)}
`

export const StyledReview = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  align-items: flex-start;
  padding: 24px;
  border: 1px solid ${colors.Gray200};
  border-radius: 36px;
  background-color: ${colors.White};
  gap: 16px;

  ${tabletPortrait(css`
    ${StyledIcon} {
      width: 17px;
      height: 17px;
      margin-right: 4px;
    }
    h3 {
      font-size: 20px;
    }
    p {
      font-size: 14px;
    }
  `)}

  ${phone(css`
    width: 100%;
  `)}
`
export const StyledReviewStars = styled.div`
  display: flex;
  flex-flow: row wrap;

  svg {
    margin-right: 8px;
  }
`

export const StyledHeadingContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 40px;
  gap: 20px;
`

export const StyledReviewsTitle = styled.div`
  display: flex;
  justify-content: center;

  ${TextStyles} {
    max-width: 700px;
    text-align: center;
  }
`

export const StyledNativeImageWrapperMobile = styled.div`
  display: none;

  ${phone(css`
    display: block;
    width: 342px;
    height: 48px;
  `)}
`

export const StyledNativeImageWrapperDesktop = styled.div`
  display: block;
  width: 448px;
  height: 64px;

  ${phone(css`
    display: none;
  `)}
`

export const StyledSubtitle = styled.span`
  font-size: 24px;
  font-style: normal;
  font-weight: 500;
  line-height: 120%;

  > b {
    color: ${colors.RoyalBlue600};
  }
`

export const StyledText = styled.p`
  align-self: stretch;
  color: ${colors.Gray800};
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 130%; /* 20.8px */
  white-space: break-spaces;
`
